import { put, call, select, takeLatest } from 'redux-saga/effects';
import types from './actionTypes';
import * as dealersActions from './actions';
import { actualCountry } from '../../selectors/country';
import apiCall from '../../helpers/axiosApiCallWrapper';
import toastr from 'toastr';
import { DEALER_BRANDS } from '../../config/settings';

function* syncDealersSaga({ params }) {
  const carBrand = params.carBrand.toLowerCase();
  const country = yield select(actualCountry);
  try {
    if (!(carBrand && DEALER_BRANDS.includes(carBrand)))
      throw new Error('Invalid car brand');

    if (!params.zipCode) {
      yield put(dealersActions.syncDealersSuccess([]));
      return;
    }

    const dealers = yield call(apiCall, 'POST', `/getDealers`, {
      carBrand,
      zipCode: params.zipCode,
      countryCode: country.countryCode,
    });

    yield put(dealersActions.syncDealersSuccess(dealers));
  } catch (error) {
    yield put(dealersActions.syncDealersFailure(error));
    toastr.error('Error syncing dealers');
  }
}

function* dealerSaga() {
  yield takeLatest(types.SYNC_DEALERS.REQUEST, syncDealersSaga);
}

export default dealerSaga;
